import "@fontsource/roboto";
import "./src/styles/foundation/variable.css";
import "./src/styles/foundation/normalize.css";
import "./src/styles/foundation/base.css";
import "./src/styles/foundation/blog-contents-style.css";

if (typeof window !== "undefined") {
  document.documentElement.style.scrollPaddingTop = "90px";
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!location.hash) return;

  const id = decodeURIComponent(location.hash.substring(1));
  const element = document.getElementById(id);
  if (!element) return;

  const isSamePage =
    prevLocation && prevLocation.pathname === location.pathname;

  if (isSamePage) {
    element.scrollIntoView({ behavior: "smooth" });
  } else {
    setTimeout(() => {
      element.scrollIntoView({ behavior: "auto" });
    }, 100);
  }
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    return false;
  }
  return true;
};
